import styled from "styled-components";
import { motion } from "framer-motion";

export const SuperHeadline = styled(motion.div)`
  font-family: "MFred";
  font-size: 13vw;
  line-height: 15vw;
  letter-spacing: 0.02em;
`;

export const Headline = styled(motion.div)`
  font-family: "MFred";
  font-size: 12.5rem;
  line-height: 11.5rem;
  letter-spacing: 0.02em;
`;
export const SubHeading = styled(motion.div)`
  font-family: "MFred";
  font-size: 11.25rem;
  line-height: 10.25rem;
  letter-spacing: 0.02em;
`;
export const Heading2 = styled(motion.h2)`
  font-family: "MFred";
  font-size: 4.5rem;

  line-height: 4.75rem;
  letter-spacing: 0em;
  margin-bottom: 1rem;
`;

export const Heading1 = styled(motion.h1)`
  font-family: "MFred";
  font-size: 6rem;

  line-height: 6.5rem;
  letter-spacing: 0em;
`;

export const Heading6 = styled(motion.h6)`
  font-family: "MFred";
  font-size: 1.75rem;
  line-height: 2rem;
  letter-spacing: 0em;
`;

export const Heading5 = styled(motion.h5)`
  font-family: "MFred";
  font-size: 2.5rem;
  line-height: 5rem;
  letter-spacing: 0em;
`;

export const Paragraph = styled(motion.p)`
  font-family: Lora;
  font-size: 1.5rem;
  font-style: normal;
  font-weight: 400;
  line-height: 2rem;
  letter-spacing: 0em;
  text-align: left;

  p {
    margin-bottom: 2rem;
  }
`;
